export default "__VITE_ASSET__99b11f42__"